import baseRoutes from '@/modules/base/routes';
import loginRoutes from '@/modules/login/routes';
import fundsRoutes from '@/modules/funds/routes';
import holdingsRoutes from '@/modules/holdings/routes';
import profileRoutes from '@/modules/profile/routes';

export default [
  ...baseRoutes,
  ...loginRoutes,
  ...fundsRoutes,
  ...holdingsRoutes,
  ...profileRoutes,
];
